import React from 'react'
import '../styles/CopyrightsTrans.css'

const CopyrightsTrans = () => {
    return (
        <div className='copyrights-trans'>
            <p>&copy; 2023, iManagement. All rights reserved.</p>
        </div>
    )
}

export default CopyrightsTrans;
